export function getWsUrl(urlString, config) {
    if (config === void 0) { config = {}; }
    var url = urlString;
    if (!/^http/.test(url))
        url = window.location.protocol + "//" + url;
    var urlInstance = new URL(url);
    urlInstance.protocol = urlInstance.protocol.replace(/^http/, 'ws');
    if (config.hostOnly !== false) {
        urlInstance.hash = '';
        urlInstance.search = '';
    }
    return urlInstance.toString();
}
export function isTest() {
    return process.env.NODE_ENV === 'test';
}
